import { usePatients } from '..';
import _ from 'lodash';
import { useMemo } from 'react';
export function useMyPatient() {
    const patients = usePatients();
    return useMemo(() => _.first(patients), [patients]);
}
